import { Component, OnInit } from '@angular/core';
import { Http, RequestOptions, Headers } from '@angular/http';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Router } from '@angular/router';
import { ContactUsForm } from '../contact-us/contact-us';

@Component({
  selector: 'index',
  templateUrl: './index-component.html'
})
export class IndexComponent implements OnInit {
  [x: string]: any;
  
  constructor(private http: Http, private toastr: ToastsManager) { 
  }

  public submittingContactForm: boolean = false;

  display: boolean;
  ngOnInit() {
  // create reusable transporter object using the default SMTP transport
  
  }

  addNewUser(user: HTMLInputElement) {
    let newUser = {
      Name : user.name,
    };

    this.http.post('http://localhost:8080/user/add/', JSON.stringify(newUser))
      .subscribe(response => {
        console.log(response.json());
      });
  }

  async submit() {
    //submission code here    
    this.submittingContactForm = true;
    await this.delay();
    let headers = new Headers({ 'Content-Type': 'application/json'});
    headers.append('Access-Control-Allow-Headers', 'Content-Type');
    headers.append('Access-Control-Allow-Methods', 'POST');
    headers.append('Access-Control-Allow-Origin', 'http://plumitmaintenance.co.za/api.php');
    headers.append('Access-Control-Allow-Origin', 'http://localhost:4200');
    let options = new RequestOptions({ headers: headers });
    let form = new ContactUsForm((<HTMLInputElement>document.getElementById("name")).value, (<HTMLInputElement>document.getElementById("email")).value, (<HTMLInputElement>document.getElementById("cellphone")).value, (<HTMLInputElement>document.getElementById("message")).value);
    this.http.post('/api.php', JSON.stringify(form), options).toPromise().then(res => {
      this.submittingContactForm = false;
      if (res)
      {        
        (<HTMLInputElement>document.getElementById("name")).value = "";
        (<HTMLInputElement>document.getElementById("email")).value = "";
        (<HTMLInputElement>document.getElementById("cellphone")).value = "";
        (<HTMLInputElement>document.getElementById("message")).value = "";
        this.router.navigate(['home']);
      }
    })
    .catch( error => { console.error(error) });
    
  }

  delay() {
    return new Promise( resolve => setTimeout(resolve, 2000) );
  }

}



// WEBPACK FOOTER //
// J:/Develop/Plumit Maintenance/src/app/index/index-component.ts